import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const ArticleEditor = ({ value, onChange }) => {
  const [htmlMode, setHtmlMode] = useState(false); // وضع تعديل HTML

  const toggleHtmlMode = () => {
    setHtmlMode(!htmlMode);
  };

  const handleHtmlChange = (e) => {
    onChange(e.target.value); // تحديث النصوص عند تعديل HTML
  };

  const handleQuillChange = (content) => {
    onChange(content); // تحديث النصوص عند تعديل المحرر المرئي
  };

  const modules = {
    toolbar: [
      [{ header: [2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"], // النصوص
      [{ list: "ordered" }, { list: "bullet" }], // القوائم
      ["link", "image"], // الروابط والصور
      [{ align: [] }], // المحاذاة
      ["clean"], // إزالة التنسيق
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
    "align",
    "table", // دعم الجداول
    "tbody",
    "tr",
    "th",
    "td",
    "strong",
  ];

  const renderContent = () => {
    if (htmlMode) {
      // عرض النصوص كـ HTML خام
      return (
        <textarea
          value={value}
          onChange={handleHtmlChange}
          style={{
            width: "100%",
            height: "400px",
            borderRadius: "8px",
            padding: "10px",
            fontFamily: "monospace",
            fontSize: "14px",
          }}
        />
      );
    } else {
      // عرض النصوص باستخدام ReactQuill
      return (
        <ReactQuill
          theme="snow"
          value={value}
          onChange={handleQuillChange}
          modules={modules}
          formats={formats}
          style={{
            height: "400px",
            marginBottom: "20px",
            borderRadius: "8px",
            background: "#fff",
          }}
        />
      );
    }
  };

  return (
    <div>
      <button
        onClick={toggleHtmlMode}
        style={{
          marginBottom: "10px",
          padding: "10px",
          background: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        {htmlMode ? "وضع المحرر" : "وضع HTML"}
      </button>
      {renderContent()}
    </div>
  );
};

export default ArticleEditor;
